import { Injectable } from '@angular/core';
import { PopupService } from './popup.service';
import { MapService } from './map.service';
import { UserService } from './user.service';
import { NotificationService } from './notification.service';
import { LoaderService } from './loader.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from "rxjs";
import { PropertyService } from "./property.service";
import { RetailerService } from "./retailer.service";

@Injectable()
export class MyStuffService {

  mapPageNumbers: any = {
    allMaps: 1,
    received: 1,
    shared: 1,
    deleted: 1
  };

  mapCallFilters: any = {
    allMaps: 'allMaps',
    received: 'received',
    shared: 'shared',
    deleted: 'deleted'
  };

  mapEntriesAvailable: any = {
    allMaps: true,
    received: true,
    shared: true,
    deleted: true
  };

  isMapsFetching: any = {
    allMaps: false,
    received: false,
    shared: false,
    deleted: false
  };

  allRemovedItems: any = [];
  allRemovedItemsPageNumber = 1;
  recordsPerPage = 10;
  allRemovedItemsFetching = false;
  allRemovedItemsFetched = false;
  allDeletedSearchValue: string = '';
  deletedProperties: any[] = [];
  deletedRetailers: any[] = [];
  selectedRemovedItems: string = 'all';

  fetchAllMapsSource = new BehaviorSubject<boolean>(false);
  fetchAllMapsStream = this.fetchAllMapsSource.asObservable();

  fetchReceivedMapsSource = new BehaviorSubject<boolean>(false);
  fetchReceivedMapsStream = this.fetchReceivedMapsSource.asObservable();

  fetchSharedMapsSource = new BehaviorSubject<boolean>(false);
  fetchSharedMapsStream = this.fetchSharedMapsSource.asObservable();

  fetchDeletedMapsSource = new BehaviorSubject<boolean>(false);
  fetchDeletedMapsStream = this.fetchDeletedMapsSource.asObservable();

  myStuffSectionOpened: any = {
    allMaps: false,
    receivedMaps: false,
    sharedMaps: false,
    deletedMaps: false,
    allProperties: false,
    deletedProperties: false,
    allRetailers: false,
    deletedRetailers: false,
    allPins: false,
    deletedPins: false,
    allDeleted: false
  };

  constructor(public popupService: PopupService, public mapService: MapService,
    public notificationService: NotificationService, public userService: UserService, public httpClient: HttpClient,
    public loaderService : LoaderService, public propertyService : PropertyService, public retailerService: RetailerService) { }

  resetPagination(filter) {
    this.mapEntriesAvailable[filter] = true;
    this.mapPageNumbers[filter] = 1;
    this.mapService.userMaps[filter] = [];
  }

  createMapCopy(map) {
    (<any>window).saveMap.updateMapData();
    let newUserMap = {
      name: 'Copy of '+map.name,
      notes: '',
      mapData: map.mapData
    };
    this.mapService.saveMap(newUserMap).subscribe((response)=>{
      this.popupService.updateRoute('my-stuff','maps','all');
      this.fetchMapsSection();
      this.notificationService.info('A copy of the map has been created');
    },
    (error)=>{
      throw(error);
    });
  }

  switchInnerSection(event) {
    this.popupService.updateRoute('my-stuff', event.target.dataset.section);
  }

  switchSubInnerSection(event) {
    this.popupService.updateRoute('my-stuff', event.target.dataset.section, event.target.dataset.inner);
  }

  fetchAllMaps() {
    this.resetPagination(this.mapCallFilters.allMaps);
    this.getMaps(this.mapCallFilters.allMaps);
  }

  fetchReceivedMaps() {
    this.resetPagination(this.mapCallFilters.received);
    this.getMaps(this.mapCallFilters.received);
  }

  fetchSharedMaps() {
    this.resetPagination(this.mapCallFilters.shared);
    this.getMaps(this.mapCallFilters.shared);
  }

  fetchDeletedMaps() {
    this.resetPagination(this.mapCallFilters.deleted);
    this.getMaps(this.mapCallFilters.deleted);
  }

  fetchMapsSection() {
    this.resetPagination(this.mapCallFilters.allMaps);
    this.resetPagination(this.mapCallFilters.received);
    this.resetPagination(this.mapCallFilters.shared);
    this.getMaps(this.mapCallFilters.allMaps);
    this.getMaps(this.mapCallFilters.received);
    this.getMaps(this.mapCallFilters.shared);
  }

  getMaps(filter) {
    if(this.mapEntriesAvailable[filter] && !this.isMapsFetching[filter]) {
      this.isMapsFetching[filter] = true;
      this.loaderService.addGreyLoaderClass();
      this.mapService.getAllMaps({
        pageNumber: this.mapPageNumbers[filter],
        filter: filter
      }).subscribe((response: any)=>{
        this.isMapsFetching[filter] = false;
        this.loaderService.removeGreyLoaderClass();
        this.mapEntriesAvailable[filter] = (response.length >= this.mapService.recordsPerPage);
        this.mapPageNumbers[filter]++;
        response.forEach((obj)=>{
          this.mapService.userMaps[filter].push(obj);
        });
        (<any>window).Events.publish('detectChanges');
      },(error)=>{
        this.isMapsFetching[filter] = false;
        this.loaderService.removeGreyLoaderClass();
        (<any>window).Events.publish('detectChanges');
        throw(error);
      });
    }
  }

  getMapLatLng(filter, index) {
    let latLng = this.mapService.userMaps[filter][index].mapData.find((obj)=>{
      return obj.key === 'mapCenter';
    });
    let value = JSON.parse(latLng && latLng.value? latLng.value: (<any>window).MAP_CENTER);
    return (value.lat.toString() + ',' + value.lng.toString());
  }

  getMapZoom(filter, index) {
    let zoom = this.mapService.userMaps[filter][index].mapData.find((obj)=>{
      return obj.key === 'currentZoomLevel';
    });
    let value = JSON.parse(zoom && zoom.value? zoom.value : (<any>window).ZOOM_LEVELS.MAP_DEFAULT);
    return value.toString();
  }

  getSize(filter, index) {
    if(this.mapService.userMaps[filter][index].profileId !== this.userService.loggedInUser.profileId) {
      return {"width" : 232, "height" : 156};
    } else {
      return {"width" : 119, "height" : 82};
    }
  }

  getfilterRetailers(filter, index) {
    let filteredRetailers = this.mapService.userMaps[filter][index].mapData.find((obj)=>{
      return obj.key === 'filteredRetailers';
    });
    if(filteredRetailers) {
      let value = JSON.parse(filteredRetailers.value);
      return value.toString();
    } else {
      return null;
    }
  }

  getfilterPlaces(filter, index) {
    let filteredPlaces = this.mapService.userMaps[filter][index].mapData.find((obj)=>{
      return obj.key === 'filteredGooglePlaces';
    });
    if(filteredPlaces) {
      let value = JSON.parse(filteredPlaces.value);
      return value.toString();
    } else {
      return null;
    }
  }

  getAllRemovedItems(name?) {
    return this.httpClient.get(
        environment.APP.API_URL + '/my/all/deleted-items' +
        '?name=' + encodeURIComponent(this.allDeletedSearchValue) + '&pageNumber='+ this.allRemovedItemsPageNumber + '&recordsPerPage=' + this.recordsPerPage
    )
    .map((res: any) => {
      (res.length === this.recordsPerPage) ? this.allRemovedItemsPageNumber++ : this.allRemovedItemsFetched = true;
      return res;
    });
  }

  getMapLatLngAllRemovedItems(index) {
    let latLng = this.allRemovedItems[index].mapData.find((obj)=>{
      return obj.key === 'mapCenter';
    });
    let value = JSON.parse(latLng && latLng.value? latLng.value: (<any>window).MAP_CENTER);
    return (value.lat.toString() + ',' + value.lng.toString());
  }

  getMapZoomAllRemovedItems(index) {
    let zoom = this.allRemovedItems[index].mapData.find((obj)=>{
      return obj.key === 'currentZoomLevel';
    });
    let value = JSON.parse(zoom && zoom.value? zoom.value : (<any>window).ZOOM_LEVELS.MAP_DEFAULT);
    return value.toString();
  }

  resetAllRemovedItemsPagination() {
    this.allRemovedItemsPageNumber = 1;
    this.allRemovedItems = [];
    this.allRemovedItemsFetched = false;
  }

  addBackDeletedItem(item) {
    console.log(item);
    if(item.itemType === 'property') {
      item.addBack = true;
      this.updateMyProperty(item).subscribe((res) => {
        if(res) {
          let w = (<any>window);
          this.allRemovedItems = this.allRemovedItems.filter(i => i.id !== item.id);
          this.propertyService.myDeletedProperties = this.propertyService.myDeletedProperties.filter(i => i.id !== item.id);
          w.apiProperty.addNewProperty(res);
          w.Events.publish('detectChanges');
        }
      });
    }
    if(item.itemType === 'retailer') {
      this.editRetailer(item).subscribe((res) => {
        if(res) {
          let w = (<any>window);
          this.allRemovedItems = this.allRemovedItems.filter(i => i.locationId !== item.locationId);
          this.retailerService.myDeletedRetailers = this.retailerService.myDeletedRetailers.filter(i => i.locationId !== item.locationId);
          w.apiRetailer.addNewRetailer(res);
          w.Events.publish('detectChanges');
        }
      });
    }
  }

  updateMyProperty(item) {
    const headers = { 'Content-Type': 'application/json' };
    return this.httpClient.put(
      environment.APP.API_URL + '/my/property/' + item.id,
      JSON.stringify(item),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  editRetailer(data) {
    let w = (<any>window);
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(
      environment.APP.API_URL + '/rdx/retailer/location/' + data.locationId + '?r=1' +
      ((<any>window).mmap.isOrganizationEditAdmin() ? '&applyToCapsuleRecord=true' : '')+
      (data && data.skipSync ? '&skipSync=true' : '')+
      (w.mmap.adminMode? '?inhibitFork=true': ''),
      JSON.stringify(this.constructRetailerObject(data)),
      { headers }
    )
    .map((res) => {
      w.apiPolling.apiRetailerCall(res);
      return res;
    });
  }

  constructRetailerObject(data) {
    let retailerObject:any = {
      name: data.name,
      spaceNumber: data.spaceNumber,
      featured: data.featured,
      squareFeet: data.squareFeet,
      retailerId: data.retailerId,
      globalId: data.globalId,
      geom: (<any>window).getPointGeoJson(this.checkIfGeomtObjectIsLatLngInstance(data.geom))
    };
    if((data.applyToCapsuleRecord !== undefined || data.applyToCapsuleRecord !== null) && (data.approvedForPublicView !== undefined || data.approvedForPublicView !== null)) {
      retailerObject.applyToCapsuleRecord = data.applyToCapsuleRecord;
      retailerObject.approvedForPublicView = data.approvedForPublicView;
    }
    return retailerObject;
  }

  checkIfGeomtObjectIsLatLngInstance(object) {
    if (!(object instanceof (<any>window).google.maps.LatLng)) {
      object = new (<any>window).google.maps.LatLng(object.coordinates[1], object.coordinates[0]);
      return object;
    } else {
      return object;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/my-stuff.service.ts